<template>
  <v-app-bar color="blue darken-3" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
    <v-toolbar-title style="width: 400px" class="ml-0">
      <v-app-bar-nav-icon @click.stop="MOSTRAR_OCULTAR_MENU"></v-app-bar-nav-icon>
      <span class="hidden-sm-and-down font-weight-light">SuitaSIM {{ $store.state.versao }} | {{ $store.state.modulo }}</span>
    </v-toolbar-title>
    <router-link to="/" style="text-decoration: none; color: white">
      <span class="logo-jornal">
        <img v-bind:src="logotipo" :title="$store.state.usuario.site_nome + ' (' + $store.state.usuario.idSitePrincipal + '-' + $store.state.usuario.site_sigla + ')'" />
      </span>
    </router-link>
    <v-alert v-if="!$store.state.usuario.site_situacao" :value="true" color="error" style="height: 20px; margin-top: 4px; padding: 0px 4px 0px 4px">INATIVO</v-alert>
    <v-spacer></v-spacer>

    <!-- Seletor rápido de Site Principal (só aparece se usuário tiver mais de 1 site) -->
    <div style="max-width: 280px; min-width: 180px" class="mr-6 header-site-select" v-if="sitesUsuario.length > 1">
      <v-autocomplete
        v-model="idSiteSelecionado"
        :items="sitesUsuario"
        item-text="nome"
        item-value="idSite"
        :disabled="trocandoSite"
        :loading="trocandoSite"
        hide-details
        dense
        solo-inverted
        flat
        dark
        title="Site Principal"
        @change="onTrocarSiteDebounced"
        @input="onInputSite"
        @update:search-input="onPesquisarSite"
      ></v-autocomplete>
    </div>

    <!-- mensagens de erro e alertas do sistema -->
    <v-btn icon @click="dialogMensagensAbrir()">
      <v-badge color="red" left v-if="mensagensCarregadas > 0" :content="mensagensCarregadas"></v-badge>
      <v-icon title="Mensagens">mail</v-icon>
    </v-btn>

    <!-- atalhos: funções mais usadas no módulo -->
    <v-menu botton offset-y transition="slide-y-reverse-transition" v-if="atalhos">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon title="Atalhos">note_add</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="green">
        <v-icon title="Novo assinante">dashboard</v-icon>
      </v-btn>
      <v-btn fab dark small color="indigo">
        <v-icon title="Nova assinatura">question_answer</v-icon>
      </v-btn>
      <v-btn fab dark small color="red">
        <v-icon title="Novo...">account_circle</v-icon>
      </v-btn>
    </v-menu>

    <!-- troca de módulos -->
    <v-menu botton offset-y transition="slide-y-reverse-transition">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon title="Troca de módulos">apps</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="deep-purple lighten-2" class="ma-1 btn-crm" title="Módulo CRM" :href="urlCRM" target="_blank">
        <v-badge inline color="dark" content="CRM"></v-badge>
      </v-btn>
      <router-link to="/administrativo/desktop" style="text-decoration: none" v-if="moduloADM">
        <v-btn fab dark small color="grey" class="ma-1 btn-adm" title="Módulo Administrativo">
          <v-badge inline color="dark" content="ADM"></v-badge>
        </v-btn>
      </router-link>
      <router-link to="/assinaturas/desktop" style="text-decoration: none" v-if="moduloASS && $store.state.usuario.site_assinaturas">
        <v-btn fab dark small color="red" class="ma-1 btn-ass" title="Módulo Assinaturas">
          <v-badge inline color="dark" content="ASS"></v-badge>
        </v-btn>
      </router-link>
      <router-link to="/comercial/desktop" style="text-decoration: none" v-if="moduloCOM && $store.state.usuario.site_comercial">
        <v-btn fab dark small color="yellow" class="ma-1 btn-com" title="Módulo Comercial">
          <v-badge inline color="dark " content="COM"></v-badge>
        </v-btn>
      </router-link>
      <router-link to="/financeiro/desktop" style="text-decoration: none" v-if="moduloFIN">
        <v-btn fab dark small color="black" class="ma-1 btn-fin" title="Módulo Financeiro">
          <v-badge inline color="dark" content="FIN"></v-badge>
        </v-btn>
      </router-link>

      <router-link to="/flip/desktop" style="text-decoration: none" v-if="moduloFLIP && $store.state.usuario.site_flip">
        <v-btn fab dark small color="blue lighten-3" class="ma-1 btn-flip" title="Módulo Flip">
          <v-badge inline color="dark" content="FLIP"></v-badge>
        </v-btn>
      </router-link>

      <router-link to="/editorial/artigos" style="text-decoration: none" v-if="moduloEDT && $store.state.usuario.site_editorial">
        <v-btn fab dark small color="blue" class="ma-1 btn-edt" title="Módulo Editorial">
          <v-badge inline color="dark" content="EDT"></v-badge>
        </v-btn>
      </router-link>

      <router-link to="/arq/desktop" style="text-decoration: none" v-if="moduloARQ && $store.state.usuario.site_arquivoDigital" target="_blank">
        <v-btn fab dark small color="orange darken-2" class="ma-1 btn-arq" title="Módulo Arquivo Digital">
          <v-badge inline color="dark" content="ARQ"></v-badge>
        </v-btn>
      </router-link>
    </v-menu>

    <v-btn icon>
      <v-icon @click="deslogar" title="Sair">open_in_new</v-icon>
    </v-btn>

    <router-link :to="'/administrativo/usuario/' + $store.state.usuario.id">
      <v-icon :alt="$store.state.usuario.nome" :title="$store.state.usuario.nome">account_box</v-icon>
    </router-link>

    <v-btn icon @click="manual('', '')" v-if="$vuetify.breakpoint.smAndUp">
      <v-icon title="Guia">help_outline</v-icon>
    </v-btn>

    <v-dialog v-model="dialogMensagens" max-width="1000px">
      <v-card class="hide-overflow fill-height" color="white lighten-1" lighten>
        <v-card-title class="headline grey lighten-2" primary-title
          ><span>Mensagens</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="manual('Administrativo', 'Mensagens')" v-if="$vuetify.breakpoint.smAndUp">
            <v-icon title="Guia" color="blue lighten-2">help_outline</v-icon>
          </v-btn>
          <v-btn icon @click="dialogMensagens = false" dense>
            <v-icon color="darken-1" dense>cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ListaMensagens :mensagensCarregadas.sync="mensagensCarregadas" :dialogMensagens="dialogMensagens" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogContextoDesatualizado" persistent max-width="520">
      <v-card>
        <v-toolbar color="red darken-3" dark dense flat>
          <v-icon class="mr-2">warning</v-icon>
          <v-toolbar-title class="subtitle-1">Contexto desatualizado</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4">
          <p class="mb-2">O Site Principal do seu usuário foi alterado em outra aba/sessão.</p>
          <p class="mb-2">
            Esta aba ainda está operando com o site anterior
            <strong v-if="$store.state.usuario.site_nome">({{ $store.state.usuario.site_nome }})</strong>
            e foi bloqueada para evitar inconsistências.
          </p>
          <p class="mb-0">Recarregue a página para trabalhar no site atual, ou aguarde o contexto voltar ao normal.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="recarregarContexto"> <v-icon left>refresh</v-icon>Recarregar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogManual" max-width="900px">
      <v-card class="hide-overflow fill-height fill-width overflow-hidden" color="white lighten-1" lighten>
        <v-toolbar class="subheading grey lighten-2" dense>
          <span class="headline">{{ nomePagina }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogManual = false" dense>
            <v-icon color="darken-1" dense>cancel</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div ref="htmlContainer" class="mt-4 mr-4 ml-4" v-html="html"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackErro" color="error" :timeout="5000" relative bottom center>{{ mensagem }}</v-snackbar>
  </v-app-bar>
</template>

<script>
import util from "../util.js";
import { mapMutations } from "vuex"; //importa funcão do vuex para importar as mutations do store
import ListaMensagens from "@/views/components/ListaMensagens.vue";
import { api } from "@/services/api";

export default {
  components: {
    ListaMensagens
  },
  data() {
    return {
      moduloCMS: false,
      moduloADM: false,
      moduloASS: false,
      moduloCOM: false,
      moduloFIN: false,
      moduloFLIP: false,
      moduloEDT: false,
      moduloARQ: false,
      atalhos: false,
      dialogMensagens: false,
      mensagensCarregadas: 0,
      avatar: false,
      primeiraVez: true,
      dialogManual: false,
      nomePagina: "",
      html: "",
      sitesUsuario: [],
      idSiteSelecionado: null,
      trocandoSite: false,
      debounceTimerSite: null,
      dialogContextoDesatualizado: false,
      handleVisibilityChange: null,
      handleStorageChange: null,
      snackErro: false,
      mensagem: ""
    };
  },
  methods: {
    ...mapMutations(["MOSTRAR_OCULTAR_MENU"]), //Mostrar/esconder menu
    async deslogar() {
      try {
        await this.$store.dispatch("deslogarUsuario"); //loga o usuario
      } catch (e) {
        return;
      }
    },
    dialogMensagensAbrir() {
      this.dialogMensagens = true;
      if (this.primeiraVez) {
        setTimeout(() => {
          this.primeiraVez = false;
          this.dialogMensagens = false;
        }, 1);
      }
    },
    async manual(modulo, tela, item) {
      console.log(this.$route.path);

      if (modulo && tela) {
        //* ignora path
      } else {
        const caminho = util.getModuloTela(this.$route.path, this.$store.state.usuario.id);
        if (caminho) {
          modulo = caminho[0];
          tela = caminho[1];
        }
      }

      this.nomePagina = modulo + "/" + tela; //.replace(/[_]/g, " "); //INCLUÍ A TELA PARA FACILITAR O DESENVOLVIMENTO
      const urlGuia = `${process.env.VUE_APP_URL_WEB_API}manual/${modulo}/${tela}/${tela}.html`;
      this.html = "Descrição ainda não disponível";
      try {
        const response = await api.get(urlGuia);
        if (response.data) {
          var retorno = response.data;
          do {
            retorno = retorno.replace(`src="images/`, `src="${process.env.VUE_APP_URL_WEB_API}manual/${modulo}/${tela}/images/`);
          } while (retorno.includes(`src="images/`));
          this.html = retorno;

          if (item) {
            setTimeout(() => {
              this.scrollToText(item);
            }, 600);
          }
        }
      } catch {
      } finally {
        this.dialogManual = true;
      }
    },
    scrollToText(textoAlvo) {
      this.$nextTick(() => {
        const container = this.$refs.htmlContainer;
        if (!container) return;

        // Percorre os nós de texto para encontrar o termo
        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
        let node = walker.nextNode();
        while (node) {
          if (node.nodeValue.includes(textoAlvo)) {
            // Rola para o elemento pai (normalmente <div> ou <p>)
            const el = node.parentElement;
            if (el) {
              el.classList.add("scroll-target");

              el.scrollIntoView({ behavior: "smooth" });

              // Adicionar destaque (classe CSS ou estilo direto)
              el.style.transition = "background-color 0.3s ease";
              el.style.backgroundColor = "yellow";

              // Remover destaque após 2 segundos
              setTimeout(() => {
                el.style.backgroundColor = "";
              }, 2000);
            }
            break;
          }
          node = walker.nextNode();
        }
      });
    },
    async carregarSitesUsuario() {
      //* Carrega os sites vinculados ao usuário logado para o seletor rápido do Header
      try {
        if (!this.$store.state.usuario || !this.$store.state.usuario.id) {
          return;
        }
        const response = await api.get(process.env.VUE_APP_URL_WEB_API + "adm/site-usuario/usuario/" + this.$store.state.usuario.id);
        var lista = (response.data || []).filter((s) => s.site_situacao == 1);
        lista.forEach((element) => {
          element.nome = element.site_nome + " (" + element.idSite + "-" + element.sigla + ")";
        });
        this.sitesUsuario = lista;
        this.idSiteSelecionado = this.$store.state.usuario.idSitePrincipal;
      } catch (e) {
        //* Silencioso: seletor apenas não aparecerá
        this.sitesUsuario = [];
      }
    },
    onInputSite(val) {
      //* Impede limpar o campo com backspace: restaura o site atual se o valor ficar nulo
      if (!val) {
        this.$nextTick(() => {
          this.idSiteSelecionado = this.$store.state.usuario.idSitePrincipal;
        });
      }
    },
    onTrocarSiteDebounced(idSite) {
      //* Seleção explícita (clique no item): cancela auto-apply por digitação pendente e aplica imediatamente
      if (this.debounceTimerSite) clearTimeout(this.debounceTimerSite);
      this.onTrocarSite(idSite);
    },
    onPesquisarSite(val) {
      //* Digitação no autocomplete: aguarda 800ms e auto-aplica se houver match exato por sigla ou id
      if (this.debounceTimerSite) clearTimeout(this.debounceTimerSite);
      if (!val) return;
      this.debounceTimerSite = setTimeout(() => {
        const busca = val.toString().trim().toLowerCase();
        const match = this.sitesUsuario.find((s) => s.sigla?.toLowerCase() === busca || s.idSite?.toString() === busca);
        if (match && match.idSite !== this.$store.state.usuario.idSitePrincipal) {
          this.idSiteSelecionado = match.idSite;
          this.onTrocarSite(match.idSite);
        }
      }, 800);
    },
    async onTrocarSite(idSite) {
      if (!idSite || idSite == this.$store.state.usuario.idSitePrincipal) {
        return;
      }
      try {
        this.trocandoSite = true;
        await api.put(process.env.VUE_APP_URL_WEB_API + "adm/usuario/sitePrincipal/" + idSite);
        //* Avisa as demais abas abertas (storage event só dispara em OUTRAS abas) - disparado depois do PUT para garantir que o servidor já está atualizado
        try {
          localStorage.setItem("sitePrincipalAlterado", Date.now() + ":" + idSite);
        } catch (e) {
          //* Silencioso - localStorage bloqueado não impede o fluxo principal
        }
        //* Recarrega a aplicação para atualizar o contexto (direitos, menus, site_*)
        window.location.reload();
      } catch (e) {
        this.trocandoSite = false;
        //* Restaura a seleção em caso de erro
        this.idSiteSelecionado = this.$store.state.usuario.idSitePrincipal;
        this.snackErro = true;
        if (e.toString().includes("status code 400")) {
          this.mensagem = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data.length > 0) {
          this.mensagem = "ERRO: " + e.response.data[0].mensagem;
        } else {
          this.mensagem = "Erro ao buscar dados: " + e;
        }
      }
    },
    async verificarSincroniaSite() {
      //* Verifica periodicamente se o site principal do usuário no servidor bate com o site carregado nesta aba
      try {
        if (!this.$store.state.login) {
          return;
        }
        const response = await api.get(process.env.VUE_APP_URL_WEB_API + "adm/usuario/sitePrincipal");
        if (!response || !response.data) {
          return;
        }
        const idSiteServidor = response.data.idSitePrincipal;
        const idSiteLocal = this.$store.state.usuario.idSitePrincipal;
        if (idSiteServidor && idSiteLocal && idSiteServidor != idSiteLocal) {
          //* Contexto desta aba está desatualizado - bloquear
          this.dialogContextoDesatualizado = true;
        } else if (this.dialogContextoDesatualizado) {
          //* Voltou a ficar igual - desbloquear
          this.dialogContextoDesatualizado = false;
        }
      } catch (e) {
        //* Silencioso: uma falha pontual não deve bloquear a interface
      }
    },
    recarregarContexto() {
      window.location.reload();
    }
  },

  beforeMount() {
    var modulos = [];
    var direito = this.$store.state.usuario.direitos[0];
    if (direito.modulo + "_" + direito.grupo + "_" + direito.direito == "WEBSUITA_ADMIN_SUITA") {
      this.moduloCMS = true;
      modulos.push("CMS");
      this.moduloADM = true;
      modulos.push("ADM");
      this.moduloASS = true;
      modulos.push("ASS");
      this.moduloCOM = true;
      modulos.push("COM");
      this.moduloFIN = true;
      modulos.push("FIN");
      this.moduloFLIP = true;
      modulos.push("FLIP");
      this.moduloEDT = true;
      modulos.push("EDT");
      this.moduloARQ = true;
      modulos.push("ARQ");
      this.mensagens = [];
      this.atalhos = false;
    } else {
      this.$store.state.usuario.direitos.forEach((element) => {
        if (element.modulo == "CMS") {
          this.moduloCMS = true;
          if (!modulos.includes("CMS")) {
            modulos.push("CMS");
          }
        }
        if (element.modulo == "ADMINISTRATIVO") {
          this.moduloADM = true;
          if (!modulos.includes("ADM")) {
            modulos.push("ADM");
          }
        }
        if (element.modulo == "ASSINATURAS") {
          this.moduloASS = true;
          if (!modulos.includes("ASS")) {
            modulos.push("ASS");
          }
        }
        if (element.modulo == "COMERCIAL") {
          this.moduloCOM = true;
          if (!modulos.includes("COM")) {
            modulos.push("COM");
          }
        }
        if (element.modulo == "FINANCEIRO") {
          this.moduloFIN = true;
          if (!modulos.includes("FIN")) {
            modulos.push("FIN");
          }
        }
        if (element.modulo == "EDITORIAL") {
          this.moduloEDT = true;
          if (!modulos.includes("EDT")) {
            modulos.push("EDT");
          }
        }
        if (element.modulo == "FLIP") {
          this.moduloFLIP = true;
          if (!modulos.includes("FLIP")) {
            modulos.push("FLIP");
          }
        }
        if (element.modulo == "ARQUIVO_DIGITAL") {
          this.moduloARQ = true;
          if (!modulos.includes("ARQ")) {
            modulos.push("ARQ");
          }
        }
      });
    }
    if (modulos.length == 1 && this.$route.path == "/") {
      //* Se usuário só possui 1 módulo (e ainda está na raiz), já abre nele
      if (this.moduloCMS) {
        window.location.href = this.urlCMS;
      }
      if (this.moduloADM) {
        this.$router.push("/administrativo/desktop");
      }
      if (this.moduloASS && this.$store.state.usuario.site_assinaturas) {
        this.$router.push("/assinaturas/desktop");
      }
      if (this.moduloCOM && this.$store.state.usuario.site_comercial) {
        this.$router.push("/comercial/desktop");
      }
      if (this.moduloFIN) {
        this.$router.push("/financeiro/desktop");
      }
      if (this.moduloFLIP && this.$store.state.usuario.site_flip) {
        this.$router.push("/flip/desktop");
      }
      if (this.moduloEDT && this.$store.state.usuario.site_editorial) {
        this.$router.push("editorial/artigos");
      }
      if (this.moduloARQ && this.$store.state.usuario.site_arquivoDigital) {
        this.$router.push("/arq/desktop");
      }
    }
    this.dialogMensagensAbrir();
  },
  mounted() {
    //* Carrega sites do usuário para o seletor rápido
    this.carregarSitesUsuario();
    //* Verifica sincronia do site principal sempre que o usuário retornar para esta aba do navegador
    this.handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        this.verificarSincroniaSite();
      }
    };
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    window.addEventListener("focus", this.handleVisibilityChange);
    //* Dispara verificação imediata quando outra aba alterar o site principal (evita race condition ao alternar abas antes do PUT terminar na aba origem)
    this.handleStorageChange = (event) => {
      if (event.key === "sitePrincipalAlterado") {
        this.verificarSincroniaSite();
      }
    };
    window.addEventListener("storage", this.handleStorageChange);
  },
  beforeDestroy() {
    if (this.handleVisibilityChange) {
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
      window.removeEventListener("focus", this.handleVisibilityChange);
      this.handleVisibilityChange = null;
    }
    if (this.handleStorageChange) {
      window.removeEventListener("storage", this.handleStorageChange);
      this.handleStorageChange = null;
    }
  },
  computed: {
    logotipo() {
      return process.env.VUE_APP_URL_WEB_API + `arquivos/${this.$store.state.usuario.idSitePrincipal}/logo.png`;
    },
    urlSIM() {
      return window.location.host;
    },
    urlCRM() {
      return "https://crm.suita.com.br";
    }
  },
  watch: {
    mensagensCarregadas() {},
    "$store.state.acionarHeader"(params) {
      if (params) {
        this.manual(params.modulo, params.tela, params.item);

        // Opcional: resetar para evitar chamadas repetidas
        this.$store.commit("SET_ACIONAR_HEADER", null);
      }
    }
  }
};
</script>

<style>
.scroll-target {
  scroll-margin-top: 40px; /* ajuste conforme o tamanho do header fixo */
}
.header-site-select .v-select__selection,
.header-site-select input,
.header-site-select .v-list-item__title {
  font-size: 12px !important;
}
</style>
